import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { gaNewLandingAccess } from '../services/analitics';

export const useGoPrehome = () => {
  const history = useHistory();
  const { storeId, userLocale } = useSelector((state) => state.config);

  const navigateToPreHome = () => {
    sessionStorage.removeItem('welcome');
    gaNewLandingAccess(storeId, userLocale);
    history.push('/');
  };

  return { navigateToPreHome };
};
